import * as React from 'react';
import { Stack } from './Stack.js';

function HStack(props) {
    return <Stack {...props} direction="horizontal">{props.children}</Stack>;
}

export { HStack }